import { Box, H1, Text } from '@betterment/samba-react';
import { css } from '@betterment/samba-styled-system/css';
import { SambaAutoLink } from '@betterment/shared-components';
import { useNavigate, useParams } from 'react-router-dom';

import { WorkflowLayout } from '../../Shared/layout/WorkflowLayout';
import { urlBuilder } from '../../Shared/urlBuilder';
import { useTaxCoordinatedPortfolioFlowStep } from '../FlowConfig';

export const EnablementIntent = () => {
  const navigate = useNavigate();
  const { flowId } = useParams<{ flowId: string }>();

  const { commit } = useTaxCoordinatedPortfolioFlowStep('enablement_intent');

  const handleContinue = () => {
    commit({ hasIntent: true });
  };

  return (
    <WorkflowLayout
      workflowTitle={null}
      onBack={() => navigate(-1)}
      onClose={() => navigate('/')}
      pageTitle="Tax Coordinated Portfolio"
    >
      <img
        className={css({
          width: '100%',
          aspectRatio: '29/9',
          backgroundColor: 'background.neutral',
          marginBottom: 'space.400',
        })}
        alt="foo"
      />
      <H1 variant="pageTitle" css={{ marginBottom: 'space.200' }}>
        Want to keep more of what you earn?
      </H1>
      <Text as="p" variant="text100" css={{ marginBottom: 'space.200' }}>
        Since you're saving across multiple retirement accounts, each with different tax advantages, we can
        automatically place your investments where they're taxed most favorably.
      </Text>
      <Text as="p" variant="text100" css={{ marginBottom: 'space.300' }}>
        It's a strategy called asset location, and our Tax-Coordinated Portfolio feature does it for you. We're not
        changing what you're invested in, just where it’s held.
      </Text>
      <SambaAutoLink
        to={urlBuilder.getTcpDisclosure()}
        target="_blank"
        rel="noopener noreferrer"
        variant="textSecondary"
        css={{
          marginBottom: 'space.400',
        }}
      >
        Disclosure and important information
      </SambaAutoLink>
      <Box
        css={{
          display: 'flex',
          gap: 'space.200',
          flexDirection: {
            base: 'column',
            md: 'row',
          },
          alignItems: {
            base: 'stretch',
            md: 'baseline',
          },
          justifyContent: {
            base: 'center',
            md: 'flex-start',
          },
        }}
      >
        <SambaAutoLink
          to={`${urlBuilder.appTcp.absolute()}/${flowId}/accounts_selection`}
          variant="solidPrimary"
          onClick={handleContinue}
        >
          Continue
        </SambaAutoLink>
        <SambaAutoLink to="/" variant="ghostPrimary">
          Skip for now
        </SambaAutoLink>
      </Box>
    </WorkflowLayout>
  );
};
